/* Sun Potion — rotating hero (sections/sp-hero.liquid).
   One timer drives image + tagline/link together (600ms CSS crossfade).
   Slide 1 is server-rendered; slides 2+ get their src/srcset only after window load + idle,
   and a slide is only shown once its image has loaded. Pauses while the tab is hidden.
   Slow zoom (.is-live) is added after first paint.
   prefers-reduced-motion: no rotation, no zoom, and slides 2+ are never requested. */
(function () {
  if (window.__spHeroLoaded) return;
  window.__spHeroLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__spHero || reduce) return;
    root.__spHero = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-slide]'));
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-sp-line]'));
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var index = 0;
    var timer = null;

    function loadImages() {
      slides.forEach(function (s) {
        // <picture> sources first, so the browser picks the capped mobile / desktop candidate
        Array.prototype.forEach.call(s.querySelectorAll('source[data-srcset]'), function (src) {
          src.srcset = src.dataset.srcset;
          src.removeAttribute('data-srcset');
        });
        var img = s.querySelector('img[data-src]');
        if (!img) return;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    }

    function ready(i) {
      var img = slides[i].querySelector('img');
      return !img || (img.complete && img.naturalWidth > 0 && !img.hasAttribute('data-src'));
    }

    function setActive(list, i) {
      list.forEach(function (el, n) {
        var on = n === i;
        el.classList.toggle('is-active', on);
        if (on) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
        var links = el.matches('a') ? [el] : Array.prototype.slice.call(el.querySelectorAll('a'));
        links.forEach(function (a) {
          if (on) a.removeAttribute('tabindex');
          else a.setAttribute('tabindex', '-1');
        });
      });
    }

    function show(n) {
      index = n;
      setActive(slides, index);
      if (lines.length === slides.length) setActive(lines, index);
    }

    function next() {
      var n = (index + 1) % slides.length;
      if (!ready(n)) return; // wait for the image; try again next tick
      var pos = slides[n].getAttribute('data-pos') || 'left';
      if (pos === root.getAttribute('data-pos')) return show(n);
      // text changes side: fade the text out, switch side while invisible (no layout shift), fade back in
      // (visibility:hidden during the switch — layout-shift tracking ignores hidden nodes; opacity alone isn't enough)
      root.classList.add('is-swapping');
      window.setTimeout(function () {
        root.classList.add('is-swap-hidden');
        root.setAttribute('data-pos', pos);
        show(n);
        window.setTimeout(function () {
          root.classList.remove('is-swap-hidden');
          root.classList.remove('is-swapping');
        }, 60);
      }, 280);
    }

    function start() {
      stop();
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    // slow zoom starts after first paint so it never delays or alters the LCP frame
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add('is-live'); });
    });

    var kick = function () {
      loadImages();
      start();
    };
    var afterLoad = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(kick, { timeout: 2500 });
      else window.setTimeout(kick, 1200);
    };
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (timer === null) start();
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sp-hero]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
